@defer {
    <div [ngClass]="{
        'h-[100vh] overflow-hidden': sidenavOpened(),
    }">
        <app-header [data]="configResource.value()" [currentUrl]="currentRoute()" [isLoading]="!dataResource.hasValue()" [(sidenavOpened)]="sidenavOpened"></app-header>

        @if (dataResource.isLoading()) {
            <main class="w-full xl:min-h-[calc(100vh_-_180px)] lg:min-h-[calc(100vh_-_140px)] min-h-[calc(100vh_-_120px)]"></main>
        } 
        @else if (dataResource.hasValue()) {
            <main>
                <router-outlet [routerOutletData]="dataResource.value()"></router-outlet>
            </main>
        } 
        @else {
            <main class="w-full xl:min-h-[calc(100vh_-_180px)] lg:min-h-[calc(100vh_-_140px)] min-h-[calc(100vh_-_120px)]"></main>
        }
        
        <app-footer [data]="configResource.value()"></app-footer>
    </div>

    <mat-drawer-container
        [hasBackdrop]="true"
        [ngClass]="{
            '!absolute !top-0 h-full w-full !bg-transparent flex flex-col justify-between ': true,
            '!z-0': !sidenavOpened(),
            '!z-[100]': sidenavOpened(),
        }"
    >
        <mat-drawer class="p-5" mode="over" position="end" [opened]="sidenavOpened()" (closed)="closeSidenav()">
            <div class="flex items-center justify-between pb-5">
                <img [src]="logo" alt="Receeto logo" routerLink="/" class="w-[108px] h-[48px] hover:cursor-pointer">
                <button mat-icon-button class="xl:!hidden !block text-4xl mr-1" (click)="closeSidenav()">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path fill="currentColor" fill-rule="evenodd" d="M6.793 6.793a1 1 0 0 1 1.414 0L12 10.586l3.793-3.793a1 1 0 1 1 1.414 1.414L13.414 12l3.793 3.793a1 1 0 0 1-1.414 1.414L12 13.414l-3.793 3.793a1 1 0 0 1-1.414-1.414L10.586 12L6.793 8.207a1 1 0 0 1 0-1.414" clip-rule="evenodd"/>
                    </svg>
                </button>
            </div>

            <ul class="[&>li]:text-base [&>li]:font-semibold [&>li]:text-center [&>li]:py-3 [&>li]:hover:cursor-pointer">
                <li routerLink="/shoppers" routerLinkActive="!text-primary" (click)="closeSidenav()"closeSidenav>Shoppers</li>
                <li routerLink="/sellers" routerLinkActive="!text-primary" (click)="closeSidenav()"closeSidenav>Sellers</li>
                <li routerLink="/partners" routerLinkActive="!text-primary" (click)="closeSidenav()"closeSidenav>Partners</li>
                <li routerLink="/about-us" routerLinkActive="!text-primary" (click)="closeSidenav()"closeSidenav>About us</li>
                <li routerLink="/blogs" routerLinkActive="!text-primary" (click)="closeSidenav()"closeSidenav>Blogs</li>
                <li routerLink="/contact-us" routerLinkActive="!text-primary" (click)="closeSidenav()"closeSidenav>Contact us</li>
            </ul>

            <button mat-flat-button class="!h-10 w-full mt-7 !text-base" routerLink="/login" (click)="closeSidenav()">Log In</button>
        </mat-drawer>
    </mat-drawer-container>
}